(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxNetworkListSmall (
    NetworkListService, $timeout, TenantListService
  ) {
    return {
      restrict: 'EA',
      scope: {
        paginationObject: '=paginationObject',
        callback: '&callback'
      },
      templateUrl: 'app/components/sites/networkListSmall/networkListSmall.template.html',
      link: function(scope) {

        var scrollEnd = null;
        var containerHeight = null;
        scope.searchString = '';

        (function() {
          getFirstPage();
        })();

        function getFirstPage () {
          scope.paginationObject.pagingCriteria.pageSize = 20;
          scope.list = [];
          scope.loadingPage = true;
          NetworkListService.getNetworkListPaged(scope.paginationObject).then(function(networks) {

            window.scrollTo(0,0);
            scope.loadingPage = false;
            scope.totalPages = networks.page.totalPages;
            if (networks.list) {
              scope.list = networks.list;
            }
          }).catch(function(error){});
        }

        scope.textSearch = function () {
          scope.paginationObject.pagingCriteria.match = scope.searchString;
          $timeout(function () {
            getFirstPage();
          }, 500)
        }

        function getNextPage () {
          if (!scope.loadingPage && scope.totalPages > scope.paginationObject.pagingCriteria.page + 1) {
            scope.loadingPage = true;
            scope.paginationObject.pagingCriteria.page += 1;
            NetworkListService.getNetworkListPaged(scope.paginationObject).then(function(networks){

              if (networks.list) {
                scope.list = scope.list.concat(networks.list);
              }
              scope.loadingPage = false;
            }).catch(function(error){});
          }
        }

        angular.element('.pagination-small-results').on('scroll', function (event) {
          scrollEnd = event.currentTarget.clientHeight + event.currentTarget.scrollTop + 1;
          containerHeight = event.currentTarget.scrollHeight;

          if (!scope.loadingPage && scope.totalPages > scope.paginationObject.pagingCriteria.page + 1) {
            if (scrollEnd > containerHeight) {
              $timeout(function() {
                getNextPage();
              }, 300)
            }
          }
        });

        scope.$on('$destroy', function() {
          angular.element('.pagination-small-results').off('scroll');
        });

        scope.selectItem = function (event, selectedItem) {
          event.stopPropagation();
          scope.callback({selectedItem: selectedItem})
        }

        scope.closePopup = function (event) {
          scope.callback({selectItem: null});
        }

        ////////////////////////////////////////////
        ////////////////////////////////////////////
        // TOOLTIP STUFF
        ////////////////////////////////////////////
        scope.showTooltip = function (showTip, position, tooltipScope, context) {
          var offsetLeft  =  angular.element('.context-content-container')[0].offsetLeft;
          var offsetTop  =  angular.element('.context-content-container')[0].offsetTop;
          if (showTip) {
            position.startX = position.startX - offsetLeft;
            position.startY = position.startY - offsetTop;
            switch(tooltipScope) {
              case 'network':
                networkTooltip(position, context);
              break;
            }
          } else {
            scope.clearTooltip();
          }
        }

        function networkTooltip (position, network) {
          scope.clearTooltip();
          scope.tooltipContent = {
            title: 'Network',
            type: 'networkDetails',
            network: network.info,
            tenant: angular.copy(TenantListService.currentTenant)
          }
          scope.tooltipObject = {
            position: {left: position.startX - 15, top: position.startY + 20},
            contextMenu: true
          }
        }

        scope.clearTooltip = function () {
          scope.tooltipContent = null;
          scope.tooltipObject = null;
        }

      }
    };
  }

  pxNetworkListSmall.$inject = ['NetworkListService', '$timeout', 'TenantListService'];

  angular
    .module('printix-admin')
    .directive('pxNetworkListSmall', pxNetworkListSmall);

})();
